export default {
  methods: {
    selectValueOnDblclick(event) {
      const input = event.target;
      input.select();
    }
  }
}
